// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { GetProjectDetailsRoute, GetProjectEsri3DMapRoute, GetProjectFilesRoute } from 'Utils/routes';

// Where clicking a project goes. Lifted out of the grid card unchanged, so that the values it
// depends on can be sourced differently without the rule itself moving at the same time - and so
// that a test can hold it still while that happens.

export interface IProjectRouteInputs {
  projectId: string;
  // A delivered order - the only thing that makes output exist to look at.
  orderFinalized: boolean;
  expressAIReady: boolean;
  // The new Esri project viewer, behind its LaunchDarkly flag (AUT-6110).
  esriViewer: boolean;
  hasProjectDetailsTab: boolean;
}

export const resolveProjectRoute = ({
  projectId, orderFinalized, expressAIReady, esriViewer, hasProjectDetailsTab,
}: IProjectRouteInputs): string => {
  // The viewer decides on its own terms and overrides the rest, which is why it is tested first
  // here where the card assigned it last. A done order is what makes output exist, so only then
  // does the viewer have something to show; everything else opens project details. Deliberately
  // nothing fancier: placing an order auto-creates the next empty draft (order_controller
  // saveOrderStandard), so any order-status heuristic beyond "was anything delivered" reads
  // system artifacts as intent.
  if (esriViewer) {
    return orderFinalized ? GetProjectEsri3DMapRoute(projectId) : GetProjectDetailsRoute(projectId);
  }

  if (orderFinalized || expressAIReady) return GetProjectFilesRoute(projectId);

  return hasProjectDetailsTab ? GetProjectDetailsRoute(projectId) : GetProjectFilesRoute(projectId);
};

export default resolveProjectRoute;
